import "./style/index.css";
import React from "react";
import { Input } from "antd";
import trim from "lodash/trim";
import classNames from "classnames";
import WeaTools from "../../wea-tools";
import isRegExp from "lodash/isRegExp";
import isEmpty from "lodash/isEmpty";

class Main extends React.Component {
  static defaultProps = {
    style: {},
    viewAttr: 2,
    disabled: false,
    className: "",
    style: {}
  };
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : "",
      minRows: props.minRows || 2,
      maxRows: props.maxRows
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
    if (nextProps.minRows && nextProps.minRows !== this.state.minRows) {
      this.setState({ minRows: nextProps.minRows });
    }
    if (nextProps.maxRows && nextProps.maxRows !== this.state.maxRows) {
      this.setState({ maxRows: nextProps.maxRows });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.value !== this.props.value ||
      nextProps.viewAttr !== this.props.viewAttr ||
      this.state.value !== nextState.value ||
      nextProps.minRows !== this.state.minRows ||
      nextProps.maxRows !== this.state.maxRows
    );
  }
  onFocus(e) {
    this.props.onFocus &&
      this.props.onFocus(e.target.value.replace(/\u200B/g, ""));
  }
  onBlur(e) {
    const { props } = this;
    let value = e.target.value.replace(/\u200B/g, "");
    if (props.filter) {
      value = props.filter(value);
      if (e.target.value !== value) {
        this.setState({ value }, () => {
          props.onChange && props.onChange(value);
        });
      }
    }
    props.onBlur && props.onBlur(value);
  }
  setValue(v = "") {
    let { value } = this.state;
    const dom = this.refs.input.refs.input;
    dom.focus();
    value =
      dom.value.substr(0, dom.selectionStart) +
      v +
      dom.value.substring(dom.selectionStart, dom.value.length);
    this.setState({ value }, () => dom.focus());
    this.props.onChange && this.props.onChange(value);
  }
  onChange(e) {
    const { props } = this;
    let value = e.target.value.replace(/\u200B/g, "");
    if (this.props.length && value.length > this.props.length) {
      value = value.substring(0, this.props.length);
    }
    if (
      this.props.stringLength &&
      WeaTools.getStringLength(value) > this.props.stringLength
    ) {
      value = WeaTools.getStringByLength(value, this.props.stringLength);
    }
    if (
      !isEmpty(value) &&
      props.regExp &&
      isRegExp(props.regExp) &&
      !props.regExp.test(value)
    ) {
      value = this.state.value || "";
    }
    this.setState({
      value
    });
    this.props.onChange && this.props.onChange(value);
  }
  render() {
    const props = this.props;
    let { value, minRows, maxRows } = this.state;
    const {
      viewAttr,
      fieldName,
      style,
      disabled,
      textDecoration,
      placeholder,
      noResize,
      textareaStyle,
      className
    } = props;
    let styleInfo = {
      // "word-break": "break-all",
      "word-wrap": "break-word",
      width: "100%",
      ...textareaStyle
    };
    if (noResize) {
      styleInfo["resize"] = "none";
    }
    const req = classNames({
      [`${className}`]: className,
      required: viewAttr == "3" && trim(value).length === 0
    });
    if (viewAttr == 1) {
      value = WeaTools.transHTML(value);
      return (
        <span
          className={`wea-textarea-normal wea-field-readonly ${className}`}
          style={style}
          id={fieldName}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      );
    }
    return (
      <div className={`wea-textarea-normal ${req}`} style={style}>
        <Input
          {...props}
          ref="input"
          type="textarea"
          disabled={disabled}
          autosize={{ minRows: minRows, maxRows: maxRows }}
          value={value}
          id={fieldName}
          name={fieldName}
          style={styleInfo}
          className={`${textDecoration && "text-decoration"}`}
          onBlur={this.onBlur.bind(this)}
          onFocus={this.onFocus.bind(this)}
          onChange={this.onChange.bind(this)}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-textarea-normal/index.js